// Deixa a página clicável enquanto o cart drawer está aberto no desktop.
//
// Contexto: no Horizon 4, em viewport >= 990px o <theme-drawer> abre como
// dialog NÃO modal (`panel.show()`) e "espreme" a página ao lado — a página
// continua visível e, em tese, usável. Só que junto ele instala um focus trap
// (assets/focus.js -> trapFocus) com um listener `focusin` em fase de captura
// no document que, sempre que QUALQUER elemento fora do drawer recebe foco,
// devolve o foco pro primeiro focável do drawer.
//
// Efeito colateral: clicar num link do submenu do header. O mousedown foca o
// link -> o trap rouba o foco -> o link dispara `blur` com relatedTarget fora
// do menu -> header-menu.js (`deactivate`) fecha o submenu -> o mouseup cai
// no vazio e o clique nunca vira navegação. Mesma coisa com qualquer input
// da página (busca, CEP do prazo de entrega): perde o foco na hora.
//
// Correção: quando o foco é consequência de um pointerdown fora dos drawers
// abertos, este script para a propagação do `focusin` ANTES do trap rodar.
// Funciona porque os dois listeners estão no document em captura e disparam
// na ordem de registro — este arquivo carrega no scripts.liquid, o trap só é
// registrado quando o drawer abre. Foco vindo do teclado (Tab) não passa por
// pointerdown, então o trap continua valendo pra acessibilidade.
//
// No mobile (< 990px) o drawer é modal (`showModal()`): o resto da página fica
// inerte e nenhum pointerdown chega fora do drawer — este script não interfere.
(function () {
  if (window.__consoDrawerPointerFocus) return;
  window.__consoDrawerPointerFocus = true;

  var armed = false;
  var disarmTimer = 0;

  function openDrawerPanels() {
    var panels = [];
    var drawers = document.querySelectorAll('theme-drawer[open]');
    for (var i = 0; i < drawers.length; i++) {
      var panel = drawers[i].querySelector('dialog[open]');
      if (panel) panels.push(panel);
    }
    return panels;
  }

  function insideAny(panels, node) {
    for (var i = 0; i < panels.length; i++) {
      if (panels[i].contains(node)) return true;
    }
    return false;
  }

  document.addEventListener(
    'pointerdown',
    function (event) {
      var panels = openDrawerPanels();
      if (!panels.length) return;
      if (!(event.target instanceof Node) || insideAny(panels, event.target)) return;

      // O foco do clique chega entre o pointerdown e o mouseup; um tick basta.
      armed = true;
      clearTimeout(disarmTimer);
      disarmTimer = setTimeout(function () {
        armed = false;
      }, 0);
    },
    true
  );

  document.addEventListener(
    'focusin',
    function (event) {
      if (!armed) return;
      var panels = openDrawerPanels();
      if (!panels.length) return;
      if (!(event.target instanceof Node) || insideAny(panels, event.target)) return;

      event.stopImmediatePropagation();
    },
    true
  );
})();
